import React from 'react';

import { Spin, Typography } from 'antd';
import { Link } from 'react-router-dom';

import styles from './PartnerNameCell.module.css';
import { useGetPartnerHierarchy } from '../api/getPartnerHierarchy';
import { TREE_BRANCH } from '../types/partner';

const { Text } = Typography;

const DOT_SEPARATOR = ' · ';

interface ICompanyOrgsInlineProps {
  partnerId: string;
  expanded: boolean;
  onToggle: () => void;
}

export const CompanyOrgsInline = ({
  partnerId,
  expanded,
  onToggle,
}: ICompanyOrgsInlineProps) => {
  const { data, isLoading } = useGetPartnerHierarchy(partnerId, {
    enabled: !!partnerId,
  });

  const count = data?.children?.length ?? 0;

  if (count === 0) return null;

  return (
    <div className={styles.orgsLine}>
      <Text
        data-testid="partner-expand-organizations"
        type="secondary"
        className={styles.expandTrigger}
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        <span className={styles.treeBranch}>{TREE_BRANCH}</span>
        {count} {count > 1 ? 'organizations' : 'organization'}
      </Text>
      {expanded && (
        <>
          {isLoading && <Spin size="small" />}
          {!isLoading && data?.children && (
            <span
              className={styles.childrenInline}
              data-testid="partner-children-inline"
            >
              {data.children.map((child, index) => (
                <React.Fragment key={child.id}>
                  {index > 0 && (
                    <span className={styles.dotSeparator}>{DOT_SEPARATOR}</span>
                  )}
                  <Link
                    to={`/lp-village/partners/${child.id}`}
                    className={styles.childLink}
                    data-testid="partner-child-link"
                  >
                    {child.name}
                  </Link>
                </React.Fragment>
              ))}
            </span>
          )}
        </>
      )}
    </div>
  );
};
